import { initContract } from '@ts-rest/core';
import { z } from 'zod';
import { tenants } from '../../data/tenant.js';
////////////////////////////////////////////////////////////////////////////////
// getConfig
////////////////////////////////////////////////////////////////////////////////
/**
 * Every widget id doubles as the client route path ('/' + id), so the ids form
 * a closed set shared by the server navigation and the client router.
 */
export const widgetIds = [
    'dashboard',
    'new-claim',
    'pending-claims',
    'filed-claims',
    'payment-documents',
    'report-claim',
];
export const GetConfigResponse = z.strictObject({
    dashboardWidgetIds: z.array(z.string()),
    /**
     * What the user may use: the full Schadenmanager, or only the claim
     * reporting page. The client guards its routes on this field; the server
     * enforces it on every Schadenmanager endpoint.
     */
    access: z.enum(['schadenmanager', 'claim-report']),
    /**
     * The tenant the user reports claims to. Always resolved for 'claim-report'
     * users, since it selects the channel that page offers; never set for
     * 'schadenmanager' users.
     */
    tenant: z.enum(tenants).optional(),
    navigation: z.array(z.strictObject({
        widgetId: z.enum(widgetIds),
        label: z.string(),
        icon: z.string(),
        children: z.array(z.strictObject({
            widgetId: z.enum(widgetIds),
            label: z.string(),
        })),
    })),
});
////////////////////////////////////////////////////////////////////////////////
// contract
////////////////////////////////////////////////////////////////////////////////
const c = initContract();
export const addInContract = c.router({
    getConfig: {
        method: 'GET',
        path: '/get-config',
        responses: {
            200: GetConfigResponse,
        },
    },
}, {
    strictStatusCodes: true,
    pathPrefix: '/add-in',
});
